import React from "react"
import cx from "classnames"
import closeIcon from "@/public/icons/close.svg"
import PdfIcon from "@/public/icons/pdf-grey.svg"
import { truncateString } from "@/utils/helper"

const UploadImage = props => {
  const { imageList: f, onDropOff } = props

  const onDelete = file => {
    onDropOff(file)
  }

  const handleFocus = e => {
    const { currentTarget: { classList = {} } = {} } = e
    classList?.add("active-comment")
  }

  const handleBlur = e => {
    const { currentTarget: { classList = {} } = {} } = e
    classList?.remove("active-comment")
  }

  const fileSizeConverter = data => {
    let size = parseInt(data)
    for (let unit of ["b", "Kb", "Mb", "Gb"]) {
      if (size < 1024) return `${size.toFixed(2)} ${unit}`
      size /= 1024.0
    }
  }
  return (
    <div
      className={`upload-image-container ${
        Object.entries(f)?.length ? "file-5" : ""
      }`}
      id="contact-image-preview-container"
      tabIndex="0"
      role="presentation"
    >
      <div
        id="input-id-active"
        className="contact-us-image-preview"
        onClick={handleFocus}
        onBlur={handleBlur}
      >
        <div className="preview-wrapper">
          <img
            className={cx({ "image-box": f?.type !== "application/pdf" })}
            src={f?.type === "application/pdf" ? PdfIcon?.src : f?.preview}
            alt={f?.name}
          />
        </div>
        <div className="preview-desc-wrapper">
          <p className="preview-image-name">{truncateString(f?.name, 25)}</p>
          <p className="preview-image-size">{fileSizeConverter(f?.size)}</p>
        </div>
        <div id={`image-placeholder-${f?.id}`}></div>
        <span className="image-delete">
          <img
            tabIndex="0"
            className="custom-close-icone"
            onClick={() => onDelete(f)}
            src={closeIcon?.src}
            alt="close"
          />
        </span>
      </div>
    </div>
  )
}

export default UploadImage
